import { paymentMethodModel, UserRole } from '~/models';
export function isSelectablePaymentMethod(paymentMethod, isTerminatedAgreement, isSelected, isProposal, selectedPMRequiresVerification) {
    return !isTerminatedAgreement && !isSelected && !(paymentMethodModel.isBankAccount(paymentMethod) && paymentMethodModel.isErroredBankAccount(paymentMethod.bankAccount)) && !paymentMethodModel.isFailedDueToDuplicate(paymentMethod) && (isProposal || selectedPMRequiresVerification ? paymentMethodModel.requiresVerification(paymentMethod) || paymentMethodModel.isVerified(paymentMethod) : paymentMethodModel.isVerified(paymentMethod));
}
export async function fetchPaymentMethods(param) {
    let { isPreview, isSample, isProposal, vendorId, businessId, initialSelectedPaymentMethodId, getSelectedPaymentMethod, vendorGetPaymentMethod, clientGetPaymentMethod } = param;
    if (isPreview || isSample) {
        return {
            paymentMethods: []
        };
    }
    const isVendorInRelationship = businessId === vendorId;
    const fetchSelectedFundingSourceId = isProposal ? Promise.resolve(initialSelectedPaymentMethodId) : getSelectedPaymentMethod().then((selected)=>selected === null || selected === void 0 ? void 0 : selected.id);
    const [paymentMethods, selectedFundingSourceId] = await Promise.all([
        isVendorInRelationship ? vendorGetPaymentMethod() : clientGetPaymentMethod(),
        fetchSelectedFundingSourceId
    ]);
    return {
        paymentMethods,
        selectedFundingSourceId
    };
}
export function createPaymentSetupHandlers(param) {
    let { isVendor, paymentMethodHandlers, customerId, vendorId } = param;
    const createSetupIntent = ()=>isVendor ? paymentMethodHandlers.vendorCreateSetupIntent(customerId) : paymentMethodHandlers.clientCreateSetupIntent(vendorId);
    const addToBusiness = (paymentMethodId)=>isVendor ? paymentMethodHandlers.vendorAddToBusiness(paymentMethodId, customerId) : paymentMethodHandlers.clientAddToBusiness(paymentMethodId, vendorId);
    return {
        createSetupIntent,
        addToBusiness
    };
}
export function getRequiresPMActionConfirmation(isVendor, userRole, isProposal) {
    return (isVendor || userRole === UserRole.Accountant) && !isProposal;
}
export function doPaymentMethodAction(action, requiresPMActionConfirmation, openOnBehalfModal, paymentMethod) {
    if (requiresPMActionConfirmation) {
        openOnBehalfModal(action, paymentMethod);
    } else {
        action();
    }
}
export function getRenderedMenuItem(param) {
    let { disconnectable, removable, isSelected, onDisconnect, onRemove } = param;
    if (disconnectable) {
        return {
            type: 'disconnect',
            text: 'Disconnect from this agreement',
            disabled: false,
            disabledTooltipText: '',
            skin: 'error',
            onClick: onDisconnect
        };
    } else if (removable) {
        return {
            type: 'remove',
            text: 'Remove',
            disabled: false,
            disabledTooltipText: '',
            skin: 'error',
            onClick: onRemove
        };
    } else {
        return {
            type: 'disabled-remove',
            text: 'Remove',
            skin: 'secondary',
            disabled: true,
            disabledTooltipText: isSelected ? 'This payment method is being used in this agreement and therefore cannot be removed.' : 'This payment method is already being used in another agreement and therefore cannot be removed.'
        };
    }
}
